import { render, staticRenderFns } from "./DownloadJobs.vue?vue&type=template&id=312fd546&"
import script from "./DownloadJobs.vue?vue&type=script&lang=js&"
export * from "./DownloadJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports